<template>
  <div class="row p-md-5 mx-md-3 mb-5">
    <div class="col-12">
      <div class="row">
        <div class="col-md-4 text-center">
          <div class="row">
            <div class="col-12 my-md-3 text-center">
              <h3 class="my-md-5 my-3">Inventario<br/>Multifasico de<br/>la Personalidad</h3>
            </div>
            <div class="col-12 my-md-3 text-center">
              <h2 class="my-md-5 my-3">MMPI - A</h2>
            </div>
          </div>
          <div class="row d-none d-md-block">
            <div class="col-12 mt-3 text-center">
              <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <ul class="nav nav-tabs mx-3" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Instrucciones</a>
            </li>
          </ul>
          <div class="tab-content mx-2" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div class="row mt-3">
                <div class="col-12 text-center">
                  <b>Instrucciones</b>
                </div>
                <div class="col-12 mt-3">
                  A continuación encontrará una serie de oraciones o proposiciones numeradas, acerca de lo que la gente piensa o le gusta. Lea cada una de ellas y decida si es verdadera o falsa en referencia a usted.
                </div>
                <div class="col-12 mt-3">
                  Trate de ser SINCERO CONSIGO MISMO y use su propio criterio. No Señale sus respuestas pensando en lo que "es bueno" o "lo que interesa" para impresionar al examinador
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <b>Ejemplo:</b>
                </div>
                <div class="col-12 mt-3">
                  <b>Seleccionar respuesta:</b>
                </div>
                <div class="col-12 mt-3">
                  1. Posicione la flecha del mouse sobre el texto de la respuesta deseada.
                </div>
                <div class="col-12 mt-3">
                  2. Presione el botón derecho del mouse para marcar la respuesta.
                </div>
                <div class="col-12 mt-3">
                  <b>Cancelar respuesta:</b>
                </div>
                <div class="col-12 mt-3">
                  1. Posicione la flecha del mouse en la respuesta a cancelar.
                </div>
                <div class="col-12 mt-3">
                  2. Presione el botón izquierdo del mouse para quitar la marca a la respuesta.
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col" class="text-center">Pregunta</th>
                        <th scope="col" class="text-center">Falso</th>
                        <th scope="col" class="text-center">Cierto</th>
                      </tr>
                    </thead>
                    <tbody v-for="pregunta of ejemplo.preguntas" v-if="pregunta.active">
                      <tr>
                        <td>{{pregunta.numero}}</td>
                        <td>{{pregunta.nompregunta}}</td>
                        <td v-on:click="Seleccionar_Respuesta(pregunta.numero, false)" class="text-center">
                          <i v-if="pregunta.respuesta===false" class="fas fa-check"></i>
                        </td>
                        <td v-on:click="Seleccionar_Respuesta(pregunta.numero, true)" class="text-center">
                          <i v-if="pregunta.respuesta===true" class="fas fa-check"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5 text-center d-block d-md-none">
          <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      ejemplo:{
        preguntas:[
          {
            numero:1,
            active:true,
            nompregunta: 'He comprendido las instrucciones',
            respuesta: false
          }
        ]
      }
    }
  },
  methods:{
    Seleccionar_Respuesta(numero_pregunta,respuesta){
      const pregunta = this.ejemplo.preguntas.filter(function (pregunta) {
            return pregunta.active == true;
        })

        if (pregunta[0].respuesta === respuesta) pregunta[0].respuesta = ''
        else pregunta[0].respuesta = respuesta
    },
    Iniciar_Examen(){
      this.$router.push({name:'mmpia_preguntas'});
    },
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	}
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Examenes/MmpiA/Instrucciones.vue